import styles from "@components/Listings/ListingsFilter/ListingsFilter.module.scss"
import { Toggle } from "@components/Toggle"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"

export function ToggleActive() {
    const activeOnly = useFilterStore((s) => !s.listing_status_nin.length)
    const onInactiveChange = useFilterStore((s) => s.onInactiveChange)

    return (
        <div className={styles.overInactive}>
            <label htmlFor="inactiveCheck">Show inactive listings</label>
            <Toggle id="inactiveCheck" checked={activeOnly} onChange={onInactiveChange} className={styles.inactiveCheckbox} />
        </div>
    )
}
